import { VueConstructor } from 'vue/types/umd';
import { useCurrencyFilter } from './currency';
import { useDateFormatFilter } from './dateFormat';

export default function registerFilters(app: VueConstructor) {
  useCurrencyFilter(app);
  useDateFormatFilter(app);
}
